module.exports = __webpack_public_path__ + "media/wyposazenie/komfort@2x-a939a6c5.png";